var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        {
          staticClass: "box-card",
          attrs: { shadow: "never", bordered: false },
        },
        [
          _c("div", { staticClass: "tips" }, [
            _vm._v(" 全平台核销单，商户 ID 留空即查全部。金额单位是"),
            _c("b", [_vm._v("分")]),
            _vm._v("，页面已换算成元展示。 "),
            _c("br"),
            _vm._v(
              " 「商户应收」是扣掉平台服务费之后的净额；部分退款的单据这个值已按比例冲减过， 不需要再减一次。 "
            ),
          ]),
          _c(
            "el-form",
            {
              attrs: { inline: "", size: "small" },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "商户ID" } },
                [
                  _c("el-input", {
                    staticClass: "selWidthSm",
                    attrs: { clearable: "" },
                    model: {
                      value: _vm.query.merchantId,
                      callback: function ($$v) {
                        _vm.$set(_vm.query, "merchantId", _vm._n($$v))
                      },
                      expression: "query.merchantId",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "用户uid" } },
                [
                  _c("el-input", {
                    staticClass: "selWidthSm",
                    attrs: { clearable: "" },
                    model: {
                      value: _vm.query.uid,
                      callback: function ($$v) {
                        _vm.$set(_vm.query, "uid", _vm._n($$v))
                      },
                      expression: "query.uid",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "类型" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "selWidthSm",
                      attrs: { clearable: "" },
                      model: {
                        value: _vm.query.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.query, "type", $$v)
                        },
                        expression: "query.type",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "积分抵扣", value: "POINTS" },
                      }),
                      _c("el-option", {
                        attrs: { label: "订单核销", value: "ORDER" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "状态" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "selWidthSm",
                      attrs: { clearable: "" },
                      model: {
                        value: _vm.query.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.query, "status", $$v)
                        },
                        expression: "query.status",
                      },
                    },
                    _vm._l(_vm.STATUS, function (text, key) {
                      return _c("el-option", {
                        key: key,
                        attrs: { label: text, value: key },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "单号" } },
                [
                  _c("el-input", {
                    staticClass: "selWidth",
                    attrs: {
                      placeholder: "核销单号 / 业务单号",
                      clearable: "",
                    },
                    model: {
                      value: _vm.query.keyword,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.query,
                          "keyword",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "query.keyword",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "时间" } },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "daterange",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      "default-time": ["00:00:00", "23:59:59"],
                      "start-placeholder": "开始",
                      "end-placeholder": "结束",
                    },
                    model: {
                      value: _vm.dateRange,
                      callback: function ($$v) {
                        _vm.dateRange = $$v
                      },
                      expression: "dateRange",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.loadList(1)
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                  _c("el-button", { on: { click: _vm.reset } }, [
                    _vm._v("重置"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: { data: _vm.list, size: "small", border: "" },
            },
            [
              _c("el-table-column", {
                attrs: { label: "序号", width: "60", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(_vm._s(_vm.$pageIndex(scope)))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "verifyNo",
                  label: "核销单号",
                  "min-width": "180",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "类型", width: "90" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v(
                          _vm._s(row.type === "ORDER" ? "订单核销" : "积分抵扣")
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "merchantId", label: "商户", width: "80" },
              }),
              _c("el-table-column", {
                attrs: { prop: "storeId", label: "门店", width: "80" },
              }),
              _c("el-table-column", {
                attrs: { prop: "uid", label: "用户uid", width: "90" },
              }),
              _c("el-table-column", {
                attrs: { label: "订单金额", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [_vm._v(_vm._s(_vm.yuan(row.orderAmount)))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "消费明细", "min-width": "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        row.items && row.items.length
                          ? _c(
                              "div",
                              _vm._l(row.items, function (item, index) {
                                return _c(
                                  "div",
                                  { key: index, staticClass: "goods-line" },
                                  [
                                    _vm._v(" " + _vm._s(item.productName)),
                                    item.sku
                                      ? _c("span", [
                                          _vm._v(
                                            "（" + _vm._s(item.sku) + "）"
                                          ),
                                        ])
                                      : _vm._e(),
                                    _vm._v(
                                      " × " +
                                        _vm._s(item.quantity) +
                                        " ￥" +
                                        _vm._s((item.amount / 100).toFixed(2)) +
                                        " "
                                    ),
                                  ]
                                )
                              }),
                              0
                            )
                          : _c("span", { staticClass: "muted" }, [
                              _vm._v("未填写"),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "deductPoints",
                  label: "抵扣积分",
                  width: "100",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "抵扣金额", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [_vm._v(_vm._s(_vm.yuan(row.deductAmount)))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "服务费", width: "90" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [_vm._v(_vm._s(_vm.yuan(row.serviceFee)))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "商户应收", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [_vm._v(_vm._s(_vm.yuan(row.receivable)))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "状态", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              size: "mini",
                              type: _vm.statusTagType(row.status),
                            },
                          },
                          [_vm._v(_vm._s(_vm.statusText(row.status)))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "verifyTime",
                  label: "核销时间",
                  "min-width": "150",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "创建时间",
                  "min-width": "150",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "cancelReason",
                  label: "撤销原因",
                  "min-width": "140",
                  "show-overflow-tooltip": "",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pager" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  layout: "total, sizes, prev, pager, next, jumper",
                  "page-sizes": [10, 20, 50, 100],
                  "page-size": _vm.query.size,
                  "current-page": _vm.query.page,
                  total: _vm.total,
                },
                on: {
                  "size-change": _vm.onSizeChange,
                  "current-change": _vm.loadList,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }